export const isArPhone = (phone: string) => {
	/** Regex para verificar que sea un numero de Argentina. Solo podemos pedir verificacion de telefono a numeros de arg */
	const wsArRegex = /^54[\d+]/
	return wsArRegex.test(phone)
}